import { render, staticRenderFns } from "./dialogError.vue?vue&type=template&id=916ffba0&scoped=true"
import script from "./dialogError.vue?vue&type=script&lang=js"
export * from "./dialogError.vue?vue&type=script&lang=js"
import style0 from "./dialogError.vue?vue&type=style&index=0&id=916ffba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916ffba0",
  null
  
)

export default component.exports